import { Cancel01Icon } from "hugeicons-react";
import "../../../Styles/Layout/Buttons/CloseButton.css";

export const CloseButton = ({
  onClick,
  label = "Close",
}: {
  onClick: () => void;
  label?: string;
}) => {
  return (
    <button type="button" className="close-button" onClick={onClick} aria-label={label}>
      <Cancel01Icon size={18} aria-hidden />
    </button>
  );
};
